// converte valor para o formato 'R$ 00,00'
export const formatCurrency = (value) => (
  Number(value).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
);
